// src/pages/OrderConfirmationPage.js - Fixed Order ID
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import Loader from '../components/Loader';

const OrderConfirmationPage = () => {
  const { clearCart } = useCart();
  const [orderId] = useState(`TW-${Date.now()}`); // ✅ Fixed! Generate once and store
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Clear cart after successful order
    clearCart();
    setLoading(false); // Set loading to false after cart is cleared
  }, [clearCart]);

  if (loading) return <Loader text="Loading order confirmation..." />;

  return (
    <div className="order-confirmation-page">
      <section className="section">
        <div className="container">
          <div style={{
            textAlign: 'center',
            maxWidth: '600px',
            margin: '0 auto',
            padding: '4rem 0'
          }}>
            {/* Success Animation */}
            <div style={{
              fontSize: '6rem',
              marginBottom: '2rem',
              animation: 'bounce 2s infinite'
            }}>
              🎉
            </div>

            <h1 style={{
              fontSize: '3rem',
              color: 'var(--nigeria-green)',
              marginBottom: '1rem'
            }}>
              Order Confirmed!
            </h1>

            <p style={{
              fontSize: '1.2rem',
              color: 'var(--text-light)',
              marginBottom: '2rem',
              lineHeight: '1.6'
            }}>
              Thank you for choosing TiwaTinwa! Your delicious Nigerian feast is being prepared 
              with love and will be delivered to you in 30-45 minutes.
            </p>

            <div style={{
              background: 'white',
              padding: '2rem',
              borderRadius: '15px',
              boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
              marginBottom: '3rem'
            }}>
              <h3 style={{ color: 'var(--text-dark)', marginBottom: '1rem' }}>
                🚚 Order Details
              </h3>
              
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '1rem',
                textAlign: 'left'
              }}>
                <div>
                  <strong>📦 Order ID:</strong><br />
                  <span style={{ color: 'var(--nigeria-green)' }}>{orderId}</span> {/* ✅ Now it's stable! */}
                </div>
                <div>
                  <strong>⏱️ Estimated Delivery:</strong><br />
                  <span style={{ color: 'var(--nigeria-green)' }}>30-45 minutes</span>
                </div>
                <div>
                  <strong>📍 Status:</strong><br />
                  <span style={{ color: 'var(--warm-orange)' }}>🍳 Preparing...</span>
                </div>
                <div>
                  <strong>💳 Payment:</strong><br />
                  <span style={{ color: 'var(--nigeria-green)' }}>✅ Confirmed</span>
                </div>
              </div>
            </div>

            <div style={{
              display: 'flex',
              gap: '1rem',
              justifyContent: 'center',
              flexWrap: 'wrap'
            }}>
              <Link to="/menu" className="btn btn-primary">
                🍽️ Order More
              </Link>
              <Link to="/" className="btn btn-secondary">
                🏠 Back to Home
              </Link>
            </div>

            <div style={{
              marginTop: '3rem',
              padding: '1.5rem',
              background: 'linear-gradient(135deg, var(--nigeria-green), var(--warm-orange))',
              borderRadius: '15px',
              color: 'white'
            }}>
              <h4 style={{ marginBottom: '0.5rem' }}>🇳🇬 Thank You for Supporting Nigerian Cuisine!</h4>
              <p style={{ fontSize: '0.9rem', opacity: 0.9 }}>
                Your order helps us share the authentic taste of Nigeria with the world.
              </p>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% {
            transform: translateY(0);
          }
          40% {
            transform: translateY(-30px);
          }
          60% {
            transform: translateY(-15px);
          }
        }
      `}</style>
    </div>
  );
};

export default OrderConfirmationPage;